import { createStore, applyMiddleware } from 'redux';
import GlobalArtistsSearchReducer from '../reducers/GlobalArtistsSearchReducer';
import thunk from 'redux-thunk';
import createDebounce from 'redux-debounced';

const configureStore = (railsProps) => (
  createStore(GlobalArtistsSearchReducer, railsProps, applyMiddleware(createDebounce(), thunk))
);

export default configureStore;
